import { render, staticRenderFns } from "./CertificateExample.vue?vue&type=template&id=92ca08f2&scoped=true&"
import script from "./CertificateExample.vue?vue&type=script&lang=js&"
export * from "./CertificateExample.vue?vue&type=script&lang=js&"
import style0 from "./CertificateExample.vue?vue&type=style&index=0&id=92ca08f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ca08f2",
  null
  
)

export default component.exports